/* Market Dwellings — Collection filter behavior
 * - Auto-submit filter form on any input change (AJAX refresh of grid)
 * - Mobile filter drawer open/close with focus management
 * - Wishlist toggle (localStorage)
 */
(function(){
  'use strict';

  /* ---------------- AJAX filter refresh ---------------- */
  function initFilters(){
    var form = document.querySelector('[data-md-filter-form]');
    if(!form) return;
    form.addEventListener('change', function(e){
      // debounce if needed
      submitForm(form);
    });
    form.addEventListener('input', function(e){
      if(e.target.type === 'number' || e.target.type === 'text'){
        // delay for typed inputs (price range)
        clearTimeout(form._priceTimer);
        form._priceTimer = setTimeout(function(){ submitForm(form); }, 500);
      }
    });
    // Clear all link
    var clearEls = document.querySelectorAll('[data-md-clear-filters]');
    clearEls.forEach(function(el){
      el.addEventListener('click', function(e){
        e.preventDefault();
        var url = window.location.pathname;
        fetchAndReplace(url);
      });
    });
    // Active pill removal
    document.addEventListener('click', function(e){
      var pill = e.target.closest('[data-md-remove-filter]');
      if(pill){
        e.preventDefault();
        fetchAndReplace(pill.getAttribute('href'));
      }
    });
    // Sort select
    var sortSel = document.querySelector('[data-md-sort]');
    if(sortSel){
      sortSel.addEventListener('change', function(){
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sortSel.value);
        fetchAndReplace(u.pathname + u.search);
      });
    }
  }

  function submitForm(form){
    var fd = new FormData(form);
    var params = new URLSearchParams();
    fd.forEach(function(v, k){ if(v !== '') params.append(k, v); });
    // Preserve sort_by
    var u = new URL(window.location.href);
    var sort = u.searchParams.get('sort_by');
    if(sort) params.set('sort_by', sort);
    var url = window.location.pathname + '?' + params.toString();
    fetchAndReplace(url);
  }

  function fetchAndReplace(url){
    showLoading();
    fetch(url).then(function(r){ return r.text(); }).then(function(html){
      var doc = new DOMParser().parseFromString(html, 'text/html');
      // Replace the filter rail + results area
      var newMain = doc.querySelector('[data-md-results]');
      var curMain = document.querySelector('[data-md-results]');
      if(newMain && curMain) curMain.innerHTML = newMain.innerHTML;

      var newRail = doc.querySelector('[data-md-rail]');
      var curRail = document.querySelector('[data-md-rail]');
      if(newRail && curRail) curRail.innerHTML = newRail.innerHTML;

      // Update URL
      history.pushState({}, '', url);
      hideLoading();
      // Re-wire any new form element references (not needed since we preserve wrappers)
    }).catch(function(){ hideLoading(); window.location.href = url; });
  }

  function showLoading(){
    var r = document.querySelector('[data-md-results]');
    if(r) r.style.opacity = '0.5';
  }
  function hideLoading(){
    var r = document.querySelector('[data-md-results]');
    if(r) r.style.opacity = '1';
  }

  /* ---------------- Mobile filter drawer ---------------- */
  function initDrawer(){
    var openBtn = document.querySelector('[data-md-open-drawer]');
    var drawer  = document.getElementById('md-v2-filter-drawer');
    if(!openBtn || !drawer) return;
    openBtn.addEventListener('click', function(){
      drawer.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
    drawer.querySelectorAll('[data-md-close-drawer]').forEach(function(el){
      el.addEventListener('click', function(){
        drawer.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && drawer.classList.contains('open')){
        drawer.classList.remove('open');
        document.body.style.overflow = '';
      }
    });
  }

  /* ---------------- Wishlist (localStorage) ---------------- */
  var WISHLIST_KEY = 'md_v2_wishlist';
  function getWishlist(){
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); }
    catch(e){ return []; }
  }
  function saveWishlist(list){
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  }
  function toggleWishlist(id){
    var list = getWishlist();
    var idx = list.indexOf(id);
    if(idx === -1){ list.push(id); } else { list.splice(idx, 1); }
    saveWishlist(list);
    return list.indexOf(id) !== -1;
  }
  function applyWishlistState(){
    var list = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function(btnEl){
      var id = btnEl.getAttribute('data-wishlist-toggle');
      if(list.indexOf(id) !== -1 || list.indexOf(parseInt(id,10)) !== -1){
        btnEl.classList.add('active');
      }
    });
  }
  function initWishlist(){
    document.addEventListener('click', function(e){
      var btnEl = e.target.closest('[data-wishlist-toggle]');
      if(!btnEl) return;
      e.preventDefault();
      var id = btnEl.getAttribute('data-wishlist-toggle');
      var active = toggleWishlist(id);
      btnEl.classList.toggle('active', active);
    });
    applyWishlistState();
  }

  /* ---------------- Init ---------------- */
  function ready(fn){
    if(document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function(){
    initFilters();
    initDrawer();
    initWishlist();
  });

  // Expose for debugging
  window.MDCollection = {
    getWishlist: getWishlist,
    toggleWishlist: toggleWishlist,
    refresh: function(url){ fetchAndReplace(url); }
  };
})();
